import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { SessionsService } from './sessions.service';
import { SessionBase } from './session-base';

@Component({
  selector: 'session-nav',
  template: `<router-outlet></router-outlet>`
})
export class SessionsComponent extends SessionBase implements OnInit {
  public current$;
  constructor(private route: ActivatedRoute, private router: Router) {
    super();
  }

  ngOnInit() {
    super.getSession(this.route.data);
    this.current$ = this.route.url.map(() =>
      this.router.url.substring(this.router.url.lastIndexOf('/') + 1)
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/sessions/sessions.component.ts